import { useEffect, useRef, useState } from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios'
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
// eslint-disable-next-line import/no-extraneous-dependencies
import { saveAs } from 'file-saver'
import {
  getMensagensEnviadas,
  getMensagensEnviadasExport,
  getMensagensEnviadasRemetentes,
  getMensagensEnviadasResumo,
} from '../../services/MensagensEnviadasService/getMensagensEnviadas'

export function useMensagensEnviadas() {
  const navigate = useNavigate()

  const [mensagens, setMensagens] = useState<GetMensagensEnviadasType>(
    {} as GetMensagensEnviadasType
  )
  const [resumo, setResumo] = useState<GetMensagensResumoType>(
    {} as GetMensagensResumoType
  )
  const [isLoading, setIsLoading] = useState(false)
  const [remetentesDisponiveis, setRemetentesDisponiveis] = useState<string[]>(
    []
  )
  const [isExportando, setIsExportando] = useState(false)
  const exportandoRef = useRef(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [canal, setCanal] = useState<string[]>([])
  const [status, setStatus] = useState<string[]>([])
  const [remetente, setRemetente] = useState<string[]>([])
  const [dataInicio, setDataInicio] = useState('')
  const [dataFim, setDataFim] = useState('')
  const [query, setQuery] = useState('')

  const fetchMensagens = async (source: any) => {
    setIsLoading(true)
    const result = await getMensagensEnviadas(
      source,
      canal,
      status,
      [],
      remetente,
      dataInicio,
      dataFim,
      query,
      currentPage
    )
    if ('message' in result) {
      // Requisicao cancelada (troca rapida de filtro): nao mexe no loading, pois outro fetch ja esta em voo.
      if (result.message === 'cancelToken') {
        return
      }
      // Zera a tabela em vez de manter o recorte anterior: senão ela mostraria os filtros antigos
      // com o botão de exportar habilitado, e o arquivo sairia com os filtros novos.
      setMensagens({} as GetMensagensEnviadasType)
      toast.error(result.message)
    } else {
      setMensagens(result)
    }
    setIsLoading(false)
  }

  const fetchResumo = async (source: any) => {
    const result = await getMensagensEnviadasResumo(
      source,
      canal,
      status,
      [],
      remetente,
      dataInicio,
      dataFim,
      query
    )
    if (!('message' in result)) {
      setResumo(result)
    }
  }

  // Opcoes do filtro: uma vez por visita. Falha so deixa o filtro sem opcoes — a listagem segue.
  useEffect(() => {
    getMensagensEnviadasRemetentes().then(result => {
      if (Array.isArray(result)) {
        setRemetentesDisponiveis(result)
      }
    })
  }, [])

  useEffect(() => {
    const source = axios.CancelToken.source()
    fetchMensagens(source)
    fetchResumo(source)
    return () => source.cancel('cancelToken')
  }, [
    JSON.stringify({
      currentPage,
      canal,
      status,
      remetente,
      dataInicio,
      dataFim,
      query,
    }),
  ])

  // Qualquer mudanca de filtro volta para a primeira pagina.
  const onChangeCanal = (value: string[]) => {
    setCanal(value)
    setCurrentPage(1)
  }
  const onChangeStatus = (value: string[]) => {
    setStatus(value)
    setCurrentPage(1)
  }
  const onChangeRemetente = (value: string[]) => {
    setRemetente(value)
    setCurrentPage(1)
  }
  const onChangeDataInicio = (value: string) => {
    setDataInicio(value)
    setCurrentPage(1)
  }
  const onChangeDataFim = (value: string) => {
    setDataFim(value)
    setCurrentPage(1)
  }
  const onChangeQuery = (value: string) => {
    setQuery(value)
    setCurrentPage(1)
  }

  // Exporta o recorte INTEIRO dos filtros atuais, nao so a pagina visivel.
  const exportar = async () => {
    if (exportandoRef.current) return
    exportandoRef.current = true
    setIsExportando(true)
    try {
      const result = await getMensagensEnviadasExport(
        canal,
        status,
        [],
        remetente,
        dataInicio,
        dataFim,
        query
      )
      if (result instanceof Blob) {
        saveAs(result, 'MensagensEnviadas.xlsx')
      } else {
        // Acima do teto a API recusa com a orientacao de como reduzir o recorte — nunca corta o arquivo.
        toast.error(result.message)
      }
    } finally {
      // Sem o finally, uma falha do saveAs deixaria o botao preso em "Gerando…" para sempre.
      exportandoRef.current = false
      setIsExportando(false)
    }
  }

  const goToDetalhe = (id: number) => {
    navigate(`/historico-mensagens/${id}`)
  }

  return {
    mensagens,
    resumo,
    isLoading,
    currentPage,
    setCurrentPage,
    canal,
    status,
    remetente,
    remetentesDisponiveis,
    onChangeCanal,
    onChangeStatus,
    onChangeRemetente,
    onChangeDataInicio,
    onChangeDataFim,
    onChangeQuery,
    exportar,
    isExportando,
    goToDetalhe,
  }
}
